/* eslint-disable */
import * as THREE from 'three'
import app from '../AppSettings'
import config from '../config'

export function addFieldComponents(scene, distance) {
    const field = scene.getObjectByName('field-components')
    if (field) {
        scene.remove(field)
    }
    const group = new THREE.Group()
    group.name = 'field-components'

    const homePlate = { x: 0, y: 0 }
    const first = { x: 0, y: 0 }
    const second = { x: 0, y: 0 }
    const third = { x: 0, y: 0 }
    const n = Math.sqrt((90 * 90) / 2)
    const baseRadius = Math.sqrt(2)
    first.x = homePlate.x + n - baseRadius
    first.y = homePlate.y + n
    second.x = homePlate.x
    second.y = homePlate.y + 2 * n
    third.x = homePlate.x - n + baseRadius
    third.y = homePlate.y + n

    addHomePlate(group)
    addBase(group, new THREE.Vector3(first.x, first.y, 3))
    addBase(group, new THREE.Vector3(second.x, second.y, 3))
    addBase(group, new THREE.Vector3(third.x, third.y, 3))
    addFoulPoles(group, distance)
    addRubber(group)
    addMound(group)
    group.add(baseline('l', distance.lf))
    group.add(baseline('r', distance.rf))

    scene.add(group)
}

export function addFoulPoles(scene, distance) {
    scene.add(foulPole('l', distance.lf))
    scene.add(foulPole('r', distance.rf))
}

const poleGeometry = new THREE.CylinderGeometry(1, 1, 90, 8)
const poleMaterial = new THREE.MeshBasicMaterial({ color: config.foulPole })

function foulPole(side, dist) {
    let v
    let vOffset
    const offset = 1.5 // feet
    const cylinder = new THREE.Mesh(poleGeometry, poleMaterial)

    if (side === 'l') {
        v = new THREE.Vector3(-1, 1, 0).normalize().multiplyScalar(dist)
        vOffset = new THREE.Vector3(-1, -1, 0)
            .normalize()
            .multiplyScalar(offset)
    } else {
        v = new THREE.Vector3(1, 1, 0).normalize().multiplyScalar(dist)
        vOffset = new THREE.Vector3(1, -1, 0).normalize().multiplyScalar(offset)
    }
    v.add(vOffset)
    cylinder.rotateX(-0.5 * Math.PI)
    cylinder.position.set(v.x, v.y, 45)

    return cylinder
}

export function addFoulLines(scene) {
    const foul = scene.getObjectByName('foul-lines')
    if (field) {
        scene.remove(field)
    }
}

export function addMound(scene) {
    const moundShape = new THREE.Shape()
    const radius = 8
    const extrudeSettings = {
        amount: 2,
        bevelEnabled: true,
        bevelSegments: 2,
        steps: 2,
        bevelSize: 1,
        bevelThickness: 1,
    }
    const x = 0
    const y = 59
    const z = 0.75
    const rx = 0
    const ry = 0
    const rz = 0
    const s = 1

    moundShape.moveTo(0, 0)
    moundShape.absarc(0, 0, radius, 0, 2 * Math.PI, false)
    const geometry = new THREE.ExtrudeGeometry(moundShape, extrudeSettings)
    const mesh = new THREE.Mesh(
        geometry,
        new THREE.MeshPhongMaterial({ color: config.moundColor })
    )

    mesh.position.set(x, y, z)
    mesh.rotation.set(rx, ry, rz)

    scene.add(mesh)
}

export function addHomePlate(scene) {
    const rectWidth = 17 / 12.0
    const halfRectWidth = 0.5 * rectWidth
    const rectLength = 17 / 12.0
    const halfRectLength = 0.5 * rectWidth

    const rectShape = new THREE.Shape()
    rectShape.moveTo(0, 0)
    rectShape.lineTo(halfRectWidth, halfRectLength)
    rectShape.lineTo(halfRectWidth, rectLength)
    rectShape.lineTo(-halfRectWidth, rectLength)
    rectShape.lineTo(-halfRectWidth, halfRectLength)
    rectShape.lineTo(0, 0)

    const rectGeom = new THREE.ExtrudeGeometry(rectShape, {
        amount: 0.1,
        steps: 1,
        bevelEnabled: false,
    })
    const mat = new THREE.MeshBasicMaterial({ color: config.baseColor })
    const rectMesh = new THREE.Mesh(rectGeom, mat)
    rectMesh.position.z = 3
    rectMesh.name = 'home plate'
    scene.add(rectMesh)
    //    let base = new THREE.Vector3(0,0,0);
    //    addBase(scene, base);
}

export function addFirstBase(scene) {
    const base = new THREE.Vector3(63.6, 63.6, 0)
    addBase(scene, base)
}

export function addThirdBase(scene) {
    const base = new THREE.Vector3(-63.6, 63.6, 0)
    addBase(scene, base)
}

export function addSecondBase(scene) {
    const base = new THREE.Vector3(0, 127, 0)
    addBase(scene, base)
}

const baseGeometry = new THREE.BoxGeometry(2, 2, 0.5)
const baseMaterial = new THREE.MeshLambertMaterial({ color: config.baseColor })

function addBase(scene, base) {
    const box = new THREE.Mesh(baseGeometry, baseMaterial)
    box.position.x = base.x
    box.position.y = base.y
    box.position.z = 3

    box.rotation.z = 0.25 * Math.PI
    scene.add(box)
}

function baseline(side, dist) {
    dist = dist || 300

    const isleft = side === 'l'
    const width = 1
    const halfWidth = 0.5 * width
    const halfLength = 0.5 * dist
    const theta = isleft ? 0.25 * Math.PI : -0.25 * Math.PI
    const geometry = new THREE.BoxGeometry(width, 0.01, dist)
    const material = new THREE.MeshLambertMaterial({ color: config.chalk })
    const box = new THREE.Mesh(geometry, material)

    box.rotateX(0.5 * Math.PI)
    box.rotateY(theta)
    box.translateX(-halfWidth)
    box.translateZ(-halfLength - 4)
    box.position.z = 3

    if (isleft) {
        // hack to align exaggerated width line with coner edge of plate and 3B
        // note: translateX is in object's local coordinates
        box.translateX(width)
    }

    box.name = isleft ? 'left_baseline' : 'right_baseline'

    return box
}

export function addRubber(scene) {
    const rubber = new THREE.Vector3(0, 60.6, 0)

    const geometry = new THREE.BoxGeometry(8, 4, 3)
    const material = new THREE.MeshBasicMaterial({
        color: app.HP_COLOR,
        opacity: 1,
        transparent: false,
    })
    const cube = new THREE.Mesh(geometry, material)
    cube.position.x = rubber.x
    cube.position.y = rubber.y
    cube.position.z = 3
    scene.add(cube)
}
